import React from 'react';
import { hospitalData } from '../data/hospitalData';
import { mobileData } from '../data/mobileData';

// WARNING: This is cloaking simulation for demo purposes only. 
// Cloaking is against Google SEO guidelines and can result in a site being banned.

const Header = ({ deviceType }) => {
  const data = deviceType === 'mobile' ? mobileData : hospitalData;
  
  return (
    <header className="header">
      <div className="header-content">
        <div className="logo">
          <img 
            src={data.header.logo} 
            alt="MR Gamb Medya Logo" 
            className="logo-icon"
            style={{ width: '48px', height: '48px' }}
          />
          <div className="logo-text">
                            <h1 className="title">{data.header.title}</h1>
            <p className="subtitle">{data.header.subtitle}</p>
          </div>
        </div>
        
        {deviceType === 'desktop' && data.header.navItems && (
          <nav className="main-nav">
            {data.header.navItems.map((item, index) => (
              <a key={index} href={item.link} className="nav-item">
                {item.title}
              </a>
            ))}
          </nav>
        )}
        
        {deviceType === 'desktop' && (
          <div className="header-buttons">
            <button className="btn btn-orange" onClick={() => window.open('https://t.me/areftherat', '_blank')}>Randevu Al</button>
            <button className="btn btn-purple" onClick={() => window.open('https://t.me/areftherat', '_blank')}>İletişim</button>
          </div>
        )}
        
        <div className="device-indicator">
          <span className={`indicator ${deviceType}`}>
            {deviceType === 'mobile' ? '📱 Mobile' : '💻 Desktop'}
          </span>
        </div>
      </div>
    </header>
  );
};

export default Header;
